import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const PurchaseOrderService = {

  getAllPO: async () => {
    try {
      const response = await axios.get(ENDPOINT.PurchaseOrder);
      return response.data;
    } catch (error) {
      console.error("Error fetching Purchase Orders:", error.message);
      throw error;
    }
  },

  getPOStats: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.PurchaseOrder}/stats`);
      return response.data;
    } catch (error) {
      console.error("Error fetching PO stats:", error.message);
      throw error;
    }
  },

  getLastPO: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.PurchaseOrder}/last`);
      return response.data;
    } catch (error) {
      console.error("Error fetching last PO:", error.message);
      throw error;
    }
  },

  getPOById: async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.PurchaseOrder}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching PO:", error.message);
      throw error;
    }
  },

  createPO: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.PurchaseOrder, data, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating PO:", error.message);
      throw error;
    }
  },

  updatePO: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.PurchaseOrder}/${id}`, data, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      console.error("Error updating PO:", error.message);
      throw error;
    }
  },

  deletePO: async (id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.PurchaseOrder}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting PO:", error.message);
      throw error;
    }
  },
};